// extracted by mini-css-extract-plugin
export default {"image":"ProductVariation__image___o3a92"};